import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { get } from '@totalsoft/change-tracking-react';
import { Grid, Tooltip, TableRow } from '@mui/material';
import { IconButton, Typography } from '@totalsoft/rocket-ui';
import { Close, Check } from '@mui/icons-material';
import { TableCellWithWidth } from 'components/list/TableComponentsStyled';
import { accountStatementIndicatorModalVar } from './variables';

const AccountStatementIndicatorsListItem = ({ canWrite, statementIndicatorLens, index, onDelete, usedByPartner }) => {
  const { t } = useTranslation();
  const statementIndicator = statementIndicatorLens |> get;
  return (
    <TableRow>
      {
        <>
          <TableCellWithWidth style={{ align: 'center' }} w={5}>
            {statementIndicatorLens.orderNo |> get}
          </TableCellWithWidth>
          <TableCellWithWidth w={10}>{statementIndicatorLens.code |> get}</TableCellWithWidth>
          <TableCellWithWidth w={30}>
            <Tooltip title={statementIndicatorLens.expression |> get}>
              <Typography variant='body1'>{statementIndicatorLens.name |> get}</Typography>{' '}
            </Tooltip>
          </TableCellWithWidth>
          <TableCellWithWidth w={10}>{statementIndicatorLens.attributeName |> get}</TableCellWithWidth>
          <TableCellWithWidth style={{ align: 'center' }} w={10}>
            {' '}
            {statementIndicatorLens.computeOrder |> get}{' '}
          </TableCellWithWidth>
          <TableCellWithWidth style={{ align: 'center' }} w={10}>
            <>
              {(statementIndicatorLens.readOnlyYN |> get) === true ? <Check color='success' /> : <Close />}{' '}
              {(statementIndicatorLens.visibleYN |> get) === true ? <Check color='success' /> : <Close />}
            </>
          </TableCellWithWidth>
          <TableCellWithWidth style={{ align: 'right' }} w={10}>
            <Grid container wrap='nowrap' justifyContent='flex-end'>
              <IconButton
                type='edit'
                fontSize='medium'
                color='transparent'
                tooltip={t('Edit')}
                disabled={!canWrite}
                onClick={() =>
                  accountStatementIndicatorModalVar({
                    open: true,
                    item: {
                      statementIndicatorId: statementIndicator.statementIndicatorId,
                      code: statementIndicator.code,
                      name: statementIndicator.name,
                      attributeName: statementIndicator.attributeName,
                      expression: statementIndicator.expression,
                      financialIndicatorId: statementIndicator.financialIndicatorId,
                      financialIndicatorName: statementIndicator.financialIndicatorName,
                      orderNo: statementIndicator.orderNo,
                      computeOrder: statementIndicator.computeOrder,
                      readOnlyYN: statementIndicator.readOnlyYN,
                      visibleYN: statementIndicator.visibleYN
                    }
                  })
                }
              />
              {usedByPartner ? (
                <></>
              ) : (
                <IconButton
                  type='delete'
                  fontSize='medium'
                  color='transparent'
                  tooltip={t('Delete')}
                  onClick={() => onDelete(statementIndicator.statementIndicatorId, index)}
                  disabled={!canWrite}
                />
              )}
            </Grid>
          </TableCellWithWidth>
        </>
      }
    </TableRow>
  );
};
AccountStatementIndicatorsListItem.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  statementIndicatorLens: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  onDelete: PropTypes.func.isRequired,
  usedByPartner: PropTypes.bool
};

export default AccountStatementIndicatorsListItem;
